import { Component, OnInit } from '@angular/core';
import { NzModalRef, NzMessageService } from 'ng-zorro-antd';
import { _HttpClient } from '@delon/theme';
import {DeptService} from "@ecip/service";

@Component({
  selector: 'app-user-dept-view',
  templateUrl: './view.component.html',
})
export class UserDeptViewComponent implements OnInit {
  record: any = {};
  i: any;

  constructor(
    private modal: NzModalRef,
    public msgSrv: NzMessageService,
    public deptService: DeptService
  ) { }

  ngOnInit(): void {
    this.deptService.getById(this.record.id).subscribe(res => this.i = res);
  }

  close() {
    this.modal.destroy();
  }
}
